export default __webpack_public_path__ + "1adcec757040590704e3c93c114d6cc9.svg";